import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";
import { AutoAwesomeColouredOutlined } from "../../../styles/icons/auto-awesome-coloured-outlined";
import { CreateContentForm } from "../../create-content-card/create-content-card";

import type { DialogController } from "../../../utils/hooks/use-dialog";
import type { FC } from "react";

export const CreateWithAiDialog: FC<{
  dialog: DialogController<unknown>;
  /** The format the form starts on; Communication without it. */
  defaultFormat?: string;
}> = ({ dialog, defaultFormat }) => {
  const [submitting, setSubmitting] = useState(false);

  return (
    <Dialog open={dialog.open} onClose={dialog.handleClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <AutoAwesomeColouredOutlined />
        Create content with AI
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <CreateContentForm
            id="create-with-ai-form"
            onClose={dialog.handleClose}
            onSubmittingChange={setSubmitting}
            includeSurvey
            hideSubmit
            defaultFormat={defaultFormat}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={dialog.handleClose} data-analytics-id="dashboard-create-with-ai-cancel">
          Cancel
        </Button>
        <Button
          type="submit"
          form="create-with-ai-form"
          variant="contained"
          loading={submitting}
          data-analytics-id="dashboard-create-with-ai-create"
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};
